import script from "./Kikaku.vue?vue&type=script&setup=true&lang=ts"
export * from "./Kikaku.vue?vue&type=script&setup=true&lang=ts"

import "./Kikaku.vue?vue&type=style&index=0&id=2b7527f2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b7527f2"]])

export default __exports__